
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vida/purchase",
      function () {
        return require("private-next-pages/vida/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vida/purchase"])
      });
    }
  